export default __webpack_public_path__ + "alberta-contract.e186b506f2b40abcca37.svg";